import Axios from './Axios';
const API_URL = '/notifications';

export const NotificationForPatient = {
  patientNotificationList: (page = 1, limit = 4) => 
    Axios.get(`${API_URL}/patient`, {
      params: { page, limit }
    }),

  isReadNotificationPatient: (id) => 
   
    Axios.patch(`${API_URL}/patient/${id}/read`)
};

export const NotificationForDoctor = {
  doctorNotificationList: (page = 1, limit = 4) => 
    Axios.get(`${API_URL}/doctor`, {
      params: { page, limit }
    }),

  isReadNotificationDoctor: (id) => 
    Axios.patch(`${API_URL}/doctor/${id}/read`)
};
